export enum CurrencyPosition {
  Left = 'L',
  Right = 'R',
}
